import React from 'react';

function DefaultModal({ show, type, onClose, message = '' }) {
    // Definindo os estilos e textos baseados no tipo
    let title, headerClass, buttonText, buttonColor;
    
    switch(type) {
        case 'error':
            title = 'ATENÇÃO!';
            headerClass = 'bg-danger';
            buttonText = 'Fechar';
            buttonColor = 'btn-danger';
            break;
        case 'success':
            title = 'SUCESSO!';
            headerClass = 'bg-success';
            buttonText = 'Ok';
            buttonColor = 'btn-success';
            break;
        case 'information':
            title = 'INFORMAÇÃO';
            headerClass = 'bg-info';
            buttonText = 'Entendi';
            buttonColor = 'btn-info';
            break;
        case 'warning':
            title = 'CAMPOS PENDENTES';
            headerClass = 'bg-warning text-dark';
            buttonText = 'Fechar';
            buttonColor = 'btn-warning';
            break;
        default:
            title = 'MENSAGEM';
            headerClass = 'bg-primary';
            buttonText = 'Ok';
            buttonColor = 'btn-primary';
    }

    const formatText = (text) => {
        const safeText = text || '';
        return safeText.split(/(\*\*.+?\*\*|\*.+?\*|_.+?_|~~.+?~~)/g).map((part, i) => {
            if (typeof part !== 'string') return part;
            if (part.startsWith('**') && part.endsWith('**')) {
                return <strong key={i}>{part.slice(2, -2)}</strong>;
            }
            if (part.startsWith('*') && part.endsWith('*')) {
                return <em key={i}>{part.slice(1, -1)}</em>;
            }
            if (part.startsWith('_') && part.endsWith('_')) {
                return <u key={i}>{part.slice(1, -1)}</u>;
            }
            if (part.startsWith('~~') && part.endsWith('~~')) {
                return <del key={i}>{part.slice(2, -2)}</del>;
            }
            return part;
        });
    };

    const renderMessage = () => {
        const txt = message || '';
        const parts = txt.split('\n');
        if (type === 'warning') {
            return parts.filter(Boolean).map((line, index) => (
                <div key={index} className="d-flex align-items-center mb-1">
                    <i className="bi bi-exclamation-triangle-fill text-warning me-2"></i>
                    <span>{formatText(line)}</span>
                </div>
            ));
        }
        return parts.map((line, index) => (
            <React.Fragment key={index}>
                {formatText(line)}
                {index < parts.length - 1 && <br />}
            </React.Fragment>
        ));
    };

    return (
        <div 
            className={`modal fade ${show ? 'show d-block' : 'd-none'}`} 
            tabIndex="-1" 
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
            onClick={onClose} // Fecha ao clicar fora do modal
        >
            <div className="modal-dialog" onClick={e => e.stopPropagation()}>
                <div className="modal-content">
                    <div className={`modal-header ${headerClass} py-1`}>
                        <h6 className="modal-title text-center text-white m-0">{title}</h6>
                        <button 
                            type="button" 
                            className="btn-close btn-close-white shadow-sm p-2" 
                            onClick={onClose}
                            aria-label="Fechar"
                        ></button>
                    </div>
                    <div className="modal-body">
                        <p className="mb-0">{renderMessage()}</p>
                    </div>
                    <div className="modal-footer py-2 flex-column">
                        {type === 'warning' && (
                            <small className="text-muted mb-2">Campos faltantes não impedirão a exibição do documento.</small>
                        )}
                        <button 
                            type="button" 
                            className={`btn ${buttonColor} py-1 px-3`} 
                            onClick={onClose}
                        >
                            {buttonText}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DefaultModal;